module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n<div id=\"rightRailScroller\" class=\"right-cell-h-scrollable\">\r\n    <div class=\"rail-header\" style=\"float: right; border-left: 1px solid #d5d5d5;\">\r\n        <a id=\"right-extender\" role=\"button\" data-panel=\"property-pane\" data-toggle=\"collapse\" data-target=\"\" class=\"toggle open-panel\">\r\n            <i data-panel=\"property-pane\" class=\"fa pf-double-carot-left\"></i>\r\n        </a>\r\n        <h2 class=\"rail-header-text\">Properties</h2>\r\n        <a href=\"#\" target=\"_blank\" id=\"helpLinkDocumentation\" data-animation=\"true\" data-toggle=\"tooltip\" title data-original-title=\"Properties help\" data-placement=\"left\" class=\"help\">\r\n            <i class=\"fa pf-help\"></i>\r\n        </a>\r\n    </div>\r\n    <!-- Right Rail -->\r\n    <div id=\"right-rail\" class=\"right-rail\">\r\n        <div class=\"right-rail-content\">\r\n            <div id=\"attributes-section\" class=\"attributes-section\">\r\n\r\n            </div>\r\n            <div id=\"behaviors-section\" class=\"behaviors-section\">\r\n            </div>\r\n            <div id=\"property-tabs\" class=\"tabbable settings-style-access\">\r\n                    <!-- Mode Specific Tabs wll be loaded here -->\r\n            </div>\r\n            <div id=\"multilingual-manager\"></div>\r\n        </div>\r\n    </div>\r\n</div>\r\n")
  }
  return __output;

}